import {COLOR_THEME_DARK, DATE_FORMAT_MONTH, DEPTH_COLORS, DEPTH_COLORS_DARK, WEEKEND_WEEK_DAYS} from "../constants";
import { pink, brown, amber, grey } from '@mui/material/colors';


export const isLastRowCaller = rows => index => rows.length - 1 === index;
export const rowDateExists = (row, date) => !!row.byDate[date.index];

export const rowHaveDetails = (row, date) => rowDateExists(row, date) && row.byDate[date.index].details && row.byDate[date.index].details.length > 0;

export const rowSx = (row, index) => {
    if( row.isMaxDepth || row.isSummary ) {
        if( (index+1) %2 === 0 ) {
            return {
                background: theme => theme.palette.mode === COLOR_THEME_DARK ? '#1E1E1E' : 'rgb(245, 245, 245)' //'rgba(0, 0, 0, 0.04)'
            };
        }

        return {
            background: theme => theme.palette.mode === COLOR_THEME_DARK ? 'black' : 'white'
        };
    }

    return {
        background: theme => theme.palette.mode === COLOR_THEME_DARK ? DEPTH_COLORS_DARK[row.depth] : DEPTH_COLORS[row.depth]
    };
};

export const daySx = (day, isLastRow, isUnexpectedDuration, dayHours = null) => {
    const out = {
        width: 150
    };

    const isWeekend = day.grouped ? false : WEEKEND_WEEK_DAYS.includes(day.includes[0].isoWeekday());

    if ( isWeekend ) {
        out.backgroundColor = theme => theme.palette.mode === 'dark' ? 'weekend.dark' : 'weekend.light';
    }

    // Подсветка будних дней: зеленый если 8 часов, красный если меньше 8
    if (!isWeekend && dayHours !== null && isLastRow) {
        const targetHours = 8;
        const targetMinutes = targetHours * 60;
        
        if (dayHours >= targetMinutes) {
            // Зеленый - списано 8 часов или больше
            out.backgroundColor = 'rgba(76, 175, 80, 0.3)'; // Зеленый с прозрачностью
        } else if (dayHours > 0) {
            // Красный - списано меньше 8 часов
            out.backgroundColor = 'rgba(244, 67, 54, 0.3)'; // Красный с прозрачностью
        }
    }

    if( !isLastRow && isUnexpectedDuration === true ) {
        out.background = "rgba(255,0,0,.3);";
    }

    return out;
};

export const calculateDetailsCols = (readOnly, haveWorkerInChain, haveIssueInChain, dateFormat) => {
    let cols = 6;

    if( readOnly ) {
        cols--;
    }

    if( haveWorkerInChain ) {
        cols--;
    }

    if( haveIssueInChain ) {
        cols--;
    }

    if( dateFormat === DATE_FORMAT_MONTH ) {
        cols++;
    }

    return cols;
}